import React, {FunctionComponent, useState} from 'react'
import {PayPalComponent} from './PayPalComponent'
import {NanoId} from '../../server/model/Ids'
import {routes} from '../../server/routes'

export const PaymentComponent: FunctionComponent<{ textId: NanoId, paypalClientId: string }> = ({textId, paypalClientId}) => {
    const [status, setStatus] = useState<string | undefined>(undefined)
    const [userEmail, setUserEmail] = useState<string | undefined>(undefined)
    switch (status) {
        case undefined:
        case 'RECOVERABLE_ERROR':
        case 'NON_RECOVERABLE_ERROR':
            return <>
                <PayPalComponent textId={textId}
                                 onStatusChange={status => setStatus(status)}
                                 onEmailChange={email => setUserEmail(email)}
                                 paypalClientId={paypalClientId}
                />
            </>
        case 'REQUIRES_LOGIN':
            return <>
                <p className="text-valid text-big">Votre achat a bien été effectué 👍</p>
                <p>Veuillez vous <a href={routes.getLogin.reverse({}, {email: userEmail, postLoginRedirect: routes.getText.reverse({textId: textId, textSlug: ''})})}>connecter à votre compte</a> pour accéder au texte.</p>
            </>
        case 'SUCCESS':
            window.location.reload()
            break
    }
    return <></>
}
